module.exports = __webpack_public_path__ + "img/head-paso3.7bf581df.svg";